var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIsrael(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.393 200.348H288.13L256 144.696L223.871 200.348H159.607L191.741 256L159.607 311.652H223.871L256 367.304L288.13 311.652H352.393L320.259 256L352.393 200.348ZM295.475 256L275.739 290.188H236.264L216.525 256L236.263 221.812H275.738L295.475 256ZM256 187.623L263.346 200.347H248.656L256 187.623ZM196.786 221.812H211.478L204.132 234.536L196.786 221.812ZM196.786 290.188L204.133 277.464L211.479 290.188H196.786ZM256 324.376L248.655 311.652H263.346L256 324.376ZM315.214 290.188H300.522L307.869 277.464L315.214 290.188ZM300.522 221.812H315.214L307.868 234.536L300.522 221.812Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.357 55.6521H96.6432C73.2802 74.2601 53.2442 96.8621 37.5742 122.435H474.426C458.755 96.8631 438.719 74.2601 415.357 55.6521V55.6521Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6432 456.348H415.356C438.719 437.74 458.755 415.138 474.425 389.565H37.5742C53.2452 415.137 73.2812 437.74 96.6432 456.348V456.348Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsrael);
export default __webpack_public_path__ + "static/media/israel.83a12f68dcf457c484bf7dee2f0c815b.svg";
export { ForwardRef as ReactComponent };